module.exports = __webpack_public_path__ + "img/calendar-grey.aba6cdaf.svg";